import {NEUTRAL_PLAYER_ID} from "../../../constants/players";
import {getCapturedUnitOriginalColor} from "./getCapturedUnitOriginalColor";
import {findUnitSkinOwnerPlayer} from "../findUnitSkinOwnerPlayer";

/**
 * Пропы для UnitIcon (маска-скин + цвет/двухцветность), построенные так же,
 * как в HexGridRenderer.renderUnit - по ИСХОДНОЙ принадлежности юнита
 * (unit.factionId, unit.capturedFromOwnerId), а не по текущему owner'у.
 * Иначе соблазнённый Суккубом отряд в UI (футер, бой) отображался бы одним
 * цветом под скином фракции суккуба вместо скина/иконки исходного владельца,
 * как на игровом поле.
 *
 * owner передаётся отдельным аргументом (а не ищется по unit.ownerId), чтобы
 * работать и для превью ещё не нанятого отряда (id/ownerId/factionId у него
 * нет вовсе, а иконка должна показывать фракцию и скин currentPlayer) -
 * вызывающий код уже умеет резолвить owner с нужным фоллбэком (см.
 * SelectedUnitStats).
 * @param {Object} unit
 * @param {Object} owner - текущий владелец (или currentPlayer/нейтрал-мок
 *   для превью/нейтральных отрядов)
 * @param {Array} players
 * @returns {{playerColor: string, factionId: (string|null), hasUnitSkin: boolean, useNeutralIcon: boolean, capturedOriginalColor: (string|null)}}
 */
export const getUnitIconDisplayProps = (unit, owner, players) => {
  const originalOwnerId = unit.capturedFromOwnerId ?? unit.ownerId ?? owner.id;
  const useNeutralIcon = originalOwnerId === NEUTRAL_PLAYER_ID;
  const effectiveFactionId = useNeutralIcon ? null : (unit.factionId || owner.factionId || null);
  // Владелец скина ищется по ID исходного владельца, а не по совпадению
  // фракции: за одну фракцию в матче могут играть несколько игроков
  // (см. findUnitSkinOwnerPlayer)
  const factionOwnerPlayer = findUnitSkinOwnerPlayer(
    {factionId: effectiveFactionId, originalOwnerId},
    players
  );

  return {
    playerColor: owner.color,
    factionId: effectiveFactionId,
    hasUnitSkin: Boolean(factionOwnerPlayer?.hasUnitSkin),
    useNeutralIcon,
    capturedOriginalColor: getCapturedUnitOriginalColor(unit, players),
  };
};
